import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser"; // استيراد المكتبة
import "./Contact.css";

export default function Contact() {
  const { t } = useTranslation();
  const form = useRef(); // مرجع للفورم
  const [status, setStatus] = useState(null); // حالة الإرسال
  const [userName, setUserName] = useState(""); // تخزين الاسم لرسالة الشكر

  const sendEmail = (e) => {
    e.preventDefault();

    // استبدل القيم دي باللي هتجيبها من حسابك في EmailJS
    const serviceID = "service_a5n5gaf";
    const templateID = "template_0b9cib6";
    const publicKey = "qSQPZBJ85U5IBltX0";

    emailjs.sendForm(serviceID, templateID, form.current, publicKey)
      .then(() => {
        setStatus("success");
        form.current.reset(); // مسح البيانات من الحقول بعد النجاح
        // الرسالة هتختفي بعد 5 ثواني
        setTimeout(() => setStatus(null), 5000);
      }, (error) => {
        console.log(error.text);
        setStatus("error");
      });
  };

  return (
    <section className="contact" id="contact">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2>{t('nav_contact')}</h2>
        <p>{t('contact_sub')}</p>
      </motion.div>
      
      <motion.form 
        ref={form}
        className="contact-form" 
        onSubmit={sendEmail} // تشغيل وظيفة الإرسال
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <input 
          type="text" 
          name="from_name" // مهم جداً عشان EmailJS يعرف ياخد الاسم
          placeholder={t('placeholder_name')} 
          required 
          onChange={(e) => setUserName(e.target.value)} // تحديث الاسم أثناء الكتابة
        />
        <input 
          type="email" 
          name="user_email" // لازم تطابق المكتوب في الـ Template في الموقع
          placeholder={t('placeholder_email')} 
          required 
        />
        <textarea 
          name="message" 
          placeholder={t('placeholder_msg')} 
          rows="5" 
          required
        ></textarea>
        
        <motion.button 
          type="submit"
          whileHover={{ scale: 1.05, boxShadow: "0px 0px 15px var(--primary-color)" }}
          whileTap={{ scale: 0.95 }}
        >
          {t('btn_send')}
        </motion.button>

        {/* رسالة النجاح أو الخطأ */}
        <AnimatePresence>
          {status === "success" && (
            <motion.div 
              className="success-message"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
            >
               شكراً لتواصلك معنا يا {userName}، تم إرسال رسالتك بنجاح!
            </motion.div>
          )}
          {status === "error" && (
            <motion.div className="error-message">
              عذراً، حدث خطأ ما. حاول مرة أخرى.
            </motion.div>
          )}
        </AnimatePresence>
      </motion.form>
    </section>
  );
}